import { ORDERED_OPTIONS } from '@consts/index'
import { objectKeys } from '@helpers/utils'
import { EmptyObject } from 'types/helpers'

export type FilterOption = {
  type: string
  value: string
  position: number
}

export function getFiltersOptionsState(
  filtersOptions:
    | Partial<Record<string, string | number | string[]>>
    | EmptyObject = {}
) {
  return objectKeys(filtersOptions || {}).flatMap(filter => {
    const values = filtersOptions[filter]

    return (Array.isArray(values) ? values : [values]).map(value => ({
      type: filter,
      value: String(value),
      position: 1 + ORDERED_OPTIONS.findIndex(o => filter === o.toLowerCase())
    }))
  })
}
